import './App.css';
import '@eid-easy/eideasy-widget';
import {SigningView} from './SigningView';

function App() {

  return (
    <div className="App">
      <SigningView/>
    </div>
  );
}

export default App;
